<aside class="sidebar" [class.sidebar--collapsed]="!isOpen()">

    <!-- Logo -->
    <div class="sidebar__logo">
        <div class="sidebar__logo-icon">
            <img width="40px" src="/assets/icons/logo.svg" alt="">
        </div>
        <span class="sidebar__logo-text">OpsFlow</span>
    </div>

    <!-- Toggle Button -->
    <button class="sidebar__toggle" (click)="toggleSidebar()"
        [attr.aria-label]="isOpen() ? 'Collapse sidebar' : 'Expand sidebar'">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="sidebar__toggle-icon">
            <polyline [attr.points]="isOpen() ? '15 18 9 12 15 6' : '9 18 15 12 9 6'" />
        </svg>
    </button>

    <!-- Navigation -->
    <nav class="sidebar__nav">

        <!-- Administration section -->
        <div class="sidebar__section">
            <span class="sidebar__section-label">Administration</span>
            <ul class="sidebar__list">
                @for (item of adminItems; track item.route) {
                @if (hasNavAccess(item)) {
                <li class="sidebar__item">
                    <a [routerLink]="item.route" routerLinkActive="sidebar__link--active" class="sidebar__link">
                        <!-- [appTooltip]="item.label" [tooltipDisabled]="isOpen()"    -->
                        <img src="/assets/icons/{{item.icon}}.svg" alt="">
                        <span class="sidebar__link-label">{{ item.label }}</span>
                        @if (item.badge !== undefined) {
                        <span class="sidebar__badge">{{ item.badge | number }}</span>
                        }
                    </a>
                </li>
                }
                }
            </ul>
        </div>

        <!-- Field operations section -->
        <div class="sidebar__section">
            <span class="sidebar__section-label">Field Operations</span>
            <ul class="sidebar__list">
                @for (item of fieldOperationsItems; track item.route) {
                @if (hasNavAccess(item)) {
                <li class="sidebar__item">
                    <a [routerLink]="item.route" routerLinkActive="sidebar__link--active" class="sidebar__link">
                        <!-- [appTooltip]="item.label" [tooltipDisabled]="isOpen()"    -->
                        <img src="/assets/icons/{{item.icon}}.svg" alt="">
                        <span class="sidebar__link-label">{{ item.label }}</span>
                        @if (item.badge !== undefined) {
                        <span class="sidebar__badge">{{ item.badge | number }}</span>
                        }
                    </a>
                </li>
                }
                }
            </ul>
        </div>

        <!-- Account section -->
        <div class="sidebar__section">
            <span class="sidebar__section-label">Account</span>
            <ul class="sidebar__list">
                @for (item of accountItems; track item.route) {
                <li class="sidebar__item">
                    <a [routerLink]="item.route" routerLinkActive="sidebar__link--active" class="sidebar__link">
                        <!-- [appTooltip]="item.label" [tooltipDisabled]="isOpen()" -->
                        <img src="/assets/icons/{{item.icon}}.svg" alt="">
                        <span class="sidebar__link-label">{{ item.label }}</span>
                    </a>
                </li>
                }
            </ul>
        </div>

    </nav>

    <!-- Logout -->
    <div class="sidebar__logout">
        <button type="button" class="sidebar__link sidebar__logout-btn" (click)="onLogout()"
            [disabled]="isLoggingOut()" aria-label="Logout">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
            <span class="sidebar__link-label">Logout</span>
        </button>
    </div>

    <!-- User Profile -->
    <div class="sidebar__user">
        <div class="sidebar__user-avatar">{{ authState.currentUser()?.full_name | initials }}</div>
        <div class="sidebar__user-info">
            <span class="sidebar__user-name"> {{authState.currentUser()?.full_name}} </span>
            <span class="sidebar__user-role">{{authState.currentUser()?.role?.name | titlecase}}</span>
        </div>
        <button class="sidebar__user-bell" aria-label="Notifications">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
        </button>
    </div>

</aside>